import { JetView } from 'webix-jet';
import { allpayments } from 'models/allpayments';
import { devConfig } from 'config/config';

/**
 * Class representing the Casino Report View.
 * Extends the JetView class from webix-jet.
 */
export default class tableCasinoReportView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        var vthis = this; // Reference to the current instance
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        /**
         * Formats a percentage value.
         * @param {number} value - The value to format.
         * @returns {string} The formatted percentage string.
         */
        function percentFormat(value) {
            return webix.i18n.numberFormat(value) + '%';
        }

        // Extend the summTreeColumn filter to calculate sums for tree columns
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Variable to hold the sum result
                    var resultFormat = 0; // Variable to hold the formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) {
                            result += obj[value.columnId]; // Sum the values for level 1
                        }
                    });
                    // Format the result based on the column type
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        if (value.columnId === 'Profitness') {
                            resultFormat = webix.i18n.numberFormat(result) + '%';
                        } else {
                            resultFormat = webix.i18n.priceFormat(result);
                        }
                    }
                    node.firstChild.innerHTML = resultFormat; // Update the node with the formatted result
                },
            },
            webix.ui.datafilter.summColumn,
        );

        return {
            rows: [
                {
                    cols: [
                        {
                            type: 'wide',
                            view: 'datatable',
                            id: 'datatable',
                            css: 'webix_header_border webix_data_border webix_footer_border',
                            select: true,
                            height: 0,
                            columns: [
                                {
                                    id: 'detailTittle',
                                    header: '',
                                    width: 50,
                                    height: 25,
                                    tooltip: _('Detalles'), // Tooltip for details column
                                    template: function (obj) {
                                        return "<span class='webix_icon wxi-close details'></span>"; // Icon for details
                                    },
                                },
                                {
                                    id: 'Id',
                                    header: 'Id',
                                    width: 100,
                                    sort: 'int',
                                }, // ID column
                                {
                                    id: 'Date',
                                    header: _('Fecha'),
                                    width: 150,
                                    sort: 'int',
                                }, // Date column
                                {
                                    id: 'Username',
                                    header: _('Usuario'),
                                    width: 100,
                                    sort: 'int',
                                    template: function (obj) {
                                        return "<span class='webix_icon wxi-close user'></span> " + obj.Username; // User column with icon
                                    },
                                },
                                {
                                    id: 'Game',
                                    header: _('Juego'),
                                    width: 200,
                                    sort: 'int',
                                }, // Game column
                                {
                                    id: 'Identifier',
                                    header: _('Identificador'),
                                    width: 100,
                                    sort: 'int',
                                }, // Identifier column
                                {
                                    id: 'Type',
                                    header: '',
                                    width: 40,
                                    sort: 'int',
                                    template: function (obj) {
                                        // Icon based on the type of entry
                                        if (obj.Type == 'FS') {
                                            return "<span class='webix_icon wxi-close icon-gift'></span>";
                                        } else {
                                            return "<span class='webix_icon wxi-close icon-ticket1'></span>";
                                        }
                                    },
                                },
                                {
                                    id: 'ProviderName',
                                    header: _('Proveedor'),
                                    width: 100,
                                    sort: 'int',
                                }, // Provider column
                                {
                                    id: 'Bets',
                                    header: _('Cantidad'),
                                    width: 100,
                                    sort: 'int',
                                }, // Bets column
                                {
                                    id: 'Stakes',
                                    header: _('Apuestas'),
                                    format: webix.i18n.priceFormat, // Formatting for stakes
                                    exportType: 'number',
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'TaxBet',
                                    header: _('Impuesto Apuesta'),
                                    format: webix.i18n.priceFormat, // Formatting for tax on bets
                                    exportType: 'number',
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'Tax',
                                    header: _('Impuesto Premios'),
                                    format: webix.i18n.priceFormat, // Formatting for tax on winnings
                                    exportType: 'number',
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'FreeBalance',
                                    header: _('Saldo Gratis'),
                                    width: 200,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat, // Formatting for free balance
                                    exportType: 'number',
                                },
                                {
                                    id: 'Winnings',
                                    header: _('Premios'),
                                    format: webix.i18n.priceFormat, // Formatting for winnings
                                    exportType: 'number',
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'Profit',
                                    header: 'GGR ',
                                    format: webix.i18n.priceFormat, // Formatting for profit
                                    exportType: 'number',
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'WinningsBonus',
                                    header: _('Premios Bonos'),
                                    width: 200,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat, // Formatting for winnings bonus
                                    exportType: 'number',
                                },
                                {
                                    id: 'OtherBonus',
                                    header: _('Otros Bonos'),
                                    width: 200,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat, // Formatting for other bonuses
                                    exportType: 'number',
                                },
                                {
                                    id: 'Profitness',
                                    header: _('% GGR'),
                                    format: percentFormat, // Formatting for profit percentage
                                    width: 200,
                                    sort: 'int',
                                },
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    // Show loading overlay before data load
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    // Hide loading overlay after data load
                                    this.hideOverlay();
                                },
                            },
                            onClick: {
                                details: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
                                    // Show details based on screen size
                                    if (screen.width < 500 || screen.height < 500) {
                                        $$('windowDetailsCasino').show();
                                    } else {
                                        $$('dColl').expand();
                                        $$('formDetails').clear();
                                        $$('a5').scrollTo(
                                            0,
                                            $$('formDetails').$height + $$('datatable').$height / 2 + 55,
                                        );
                                    }
                                },
                                user: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('popupUserIframe', [item.Username]); // Trigger user popup event
                                },
                            },
                            ready: function () {
                                // Show no data overlay if there are no items
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox);
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math calculations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // Pager ID
                        },
                        {
                            type: 'wide',
                            scrollY: true,
                            height: 0,
                            view: 'treetable',
                            id: 'datatable2',
                            css: 'webix_header_border webix_data_border webix_footer_border',
                            columns: [
                                {
                                    id: 'ProviderName',
                                    header: _('Proveedor'),
                                    fillspace: 0,
                                    minWidth: 0,
                                    width: 200,
                                    sort: 'text',
                                    format: dateFormat, // Date formatting for provider name
                                    template: function (obj, common) {
                                        if (obj.$group) return common.treetable(obj, common) + obj.value; // Grouping template
                                        return obj.ProviderName; // Default provider name
                                    },
                                },
                                {
                                    id: 'Game',
                                    header: _('Juego'),
                                    width: 150,
                                    sort: 'int',
                                }, // Game column for tree table
                                {
                                    id: 'Bets',
                                    header: _('Cantidad'),
                                    width: 100,
                                    sort: 'int',
                                }, // Bets column for tree table
                                {
                                    id: 'Stakes',
                                    header: _('Apuestas'),
                                    width: 200,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat, // Formatting for stakes in tree table
                                    exportType: 'number',
                                },
                                {
                                    id: 'TaxBet',
                                    header: _('Impuesto Apuesta'),
                                    width: 200,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat, // Formatting for tax on bets in tree table
                                    exportType: 'number',
                                },
                                {
                                    id: 'TaxPayout',
                                    header: _('Impuesto Premios'),
                                    width: 200,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat, // Formatting for tax on winnings in tree table
                                    exportType: 'number',
                                },
                                {
                                    id: 'FreeBalance',
                                    header: _('Saldo Gratis'),
                                    width: 200,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat, // Formatting for free balance in tree table
                                    exportType: 'number',
                                },
                                {
                                    id: 'Winnings',
                                    header: _('Premios'),
                                    width: 200,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat, // Formatting for winnings in tree table
                                    exportType: 'number',
                                },
                                {
                                    id: 'WinningsBonus',
                                    header: _('Premios Bonos'),
                                    width: 200,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat, // Formatting for winnings bonus in tree table
                                    exportType: 'number',
                                },
                                {
                                    id: 'Bonus',
                                    header: _('Bonos'),
                                    width: 150,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat, // Formatting for bonuses in tree table
                                    exportType: 'number',
                                },
                                {
                                    id: 'Profit',
                                    header: _('GGR'),
                                    width: 150,
                                    sort: 'int',
                                    format: webix.i18n.priceFormat, // Formatting for profit in tree table
                                    exportType: 'number',
                                },
                                {
                                    id: 'Profitness',
                                    header: _('% GGR'),
                                    format: percentFormat, // Formatting for profit percentage in tree table
                                    width: 150,
                                    sort: 'int',
                                },
                            ],
                            on: {
                                onBeforeLoad: function () {
                                    // Show loading overlay before data load
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    // Hide loading overlay after data load
                                    this.hideOverlay();
                                },
                            },
                            ready: function () {
                                // Show no data overlay if there are no items
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox);
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math calculations
                            loadahead: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: {
                                size: 10000, // Page size
                                id: 'pagerr', // Pager ID
                            },
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The main data grid.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the main data grid
        var grid2 = $$('datatable2'); // Reference to the secondary data grid
        var datata = $$('datata'); // Reference to additional data
        var url = devConfig.geturlApi() + 'null/Report/GetCasinoGamesReport2'; // API URL for data
        var url2 = devConfig.geturlApi() + 'null/Report/GetCasinoGamesReport2'; // API URL for secondary data
        var flag = false; // Flag for export status
        var vthis = this; // Reference to the current instance
        grid.hide(); // Hide the main grid initially
        $$('toolbar1').hide(); // Hide the first toolbar

        // Event handler for after loading data into the secondary grid
        grid2.attachEvent('onAfterLoad', function () {
            // Group data by provider name and currency ID
            $$('datatable2').data.group({
                by: function (obj) {
                    return obj.ProviderName + '-' + obj.CurrencyId; // Grouping logic
                },
                map: {
                    ProviderName: ['ProviderName'],
                    CurrencyId: ['CurrencyId'],
                    CountryIcon: ['CountryIcon'],
                    Profit: ['Profit', 'sum'],
                    Bets: ['Bets', 'sum'],
                    Stakes: ['Stakes', 'sum'],
                    FreeBalance: ['FreeBalance', 'sum'],
                    Winnings: ['Winnings', 'sum'],
                    WinningsBonus: ['WinningsBonus', 'sum'],
                    Bonus: ['Bonus', 'sum'],
                    Profitness: [
                        'Profitness',
                        function (prop, data) {
                            console.log('data:: ', data); // Log data for debugging
                            if (!data.length) return 0; // Return 0 if no data
                            var summ1 = 0; // Sum of stakes and free balance
                            var summ2 = 0; // Sum of profit
                            for (var i = data.length - 1; i >= 0; i--) {
                                summ1 = summ1 + Math.floor(data[i].Stakes); // Sum stakes
                                if (Math.floor(data[i].FreeBalance) > 0) {
                                    summ1 = summ1 + Math.floor(data[i].FreeBalance); // Sum free balance if greater than 0
                                }
                                summ2 = summ2 + Math.floor(data[i].Profit); // Sum profit
                            }
                            return (summ2 / summ1) * 100; // Calculate profit percentage
                        },
                    ],
                },
            });

            // Group data by country icon and currency ID
            $$('datatable2').data.group({
                by: function (obj) {
                    return "<i class='flags " + obj.CountryIcon + "'></i>" + obj.CurrencyId; // Grouping logic
                },
                map: {
                    Profit: ['Profit', 'sum'],
                    Bets: ['Bets', 'sum'],
                    Stakes: ['Stakes', 'sum'],
                    FreeBalance: ['FreeBalance', 'sum'],
                    Winnings: ['Winnings', 'sum'],
                    WinningsBonus: ['WinningsBonus', 'sum'],
                    Bonus: ['Bonus', 'sum'],
                    Profitness: [
                        'Profitness',
                        function (prop, data) {
                            console.log('data:: ', data); // Log data for debugging
                            if (!data.length) return 0; // Return 0 if no data
                            var summ1 = 0; // Sum of stakes and free balance
                            var summ2 = 0; // Sum of profit
                            for (var i = data.length - 1; i >= 0; i--) {
                                summ1 = summ1 + Math.floor(data[i].Stakes); // Sum stakes
                                summ1 = summ1 + Math.floor(data[i].FreeBalance); // Sum free balance
                                summ2 = summ2 + Math.floor(data[i].Profit); // Sum profit
                            }
                            return (summ2 / summ1) * 100; // Calculate profit percentage
                        },
                    ],
                },
            });
        });

        var filter = ''; // Filter string for data loading
        // Event handler for filtering data
        this.on(this.app, 'casinoReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // String for date filters
            var string2 = ''; // String for sorting
            var providergroup = 0; // Provider group flag
            for (var i = 0; i < object.length; i++) {
                if (object[i][0] == 'IsDetails') {
                    if (object[i][1] == 0) {
                    } else {
                        providergroup = 1; // Set provider group flag
                    }
                }
                if (object[i][0] == 'Sort' && providergroup == 0) {
                    if (object[i][1] == '1') {
                        string2 = string2 + '&sort[Date]='; // Sort by date
                    } else {
                        if (object[i][1] == '2') {
                            string2 = string2 + '&sort[Username]='; // Sort by username
                        } else {
                            if (object[i][1] == '3') {
                                string2 = string2 + '&sort[Stakes]='; // Sort by stakes
                            } else {
                                if (object[i][1] == '4') {
                                    string2 = string2 + '&sort[Winnings]='; // Sort by winnings
                                }
                            }
                        }
                    }
                }
                if (object[i][0] == 'Dir' && providergroup == 0) {
                    if (object[i][1] == '0') {
                        string2 = string2 + 'asc'; // Ascending order
                    } else {
                        if (object[i][1] == '1') {
                            string2 = string2 + 'desc'; // Descending order
                        }
                    }
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date for debugging
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to filter
                    } else {
                        if (object[i][0] != 'Sort' && object[i][0] != 'Dir' && object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add start date to filter
                                string1 = string1 + '&dateTo=' + date; // Add end date to filter
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        '-' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        '-' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // End date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            '-' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            '-' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to filter
                                    }
                                }
                            }
                        }
                        if (object[i][0] === 'Date') {
                            var d = new Date(object[i][1]); // Date object
                            var dateFrom =
                                'dateFrom=' +
                                d.getFullYear() +
                                '-' +
                                ('00' + (d.getMonth() + 1)).slice(-2) +
                                '-' +
                                ('00' + d.getDate()).slice(-2);
                            string1 = string1 + '&' + dateFrom; // Add start date to filter
                            var ud = new Date(object[i][1].getFullYear(), object[i][1].getMonth() + 1, 0); // End date calculation
                            var dateTo =
                                'dateTo=' +
                                d.getFullYear() +
                                '-' +
                                ('00' + (d.getMonth() + 1)).slice(-2) +
                                '-' +
                                ('00' + ud.getDate()).slice(-2);
                            string1 = string1 + '&' + dateTo; // Add end date to filter
                        }
                    }
                }
            }
            if (providergroup == 0) {
                grid.show(); // Show main grid
                grid2.hide(); // Hide secondary grid
                grid.clearAll(); // Clear main grid data
                grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1 + string2).then(function (data) {
                    data = data.json(); // Parse loaded data
                    var columnsGrid = []; // Array to hold column IDs
                    grid.config.columns.forEach((item) => {
                        columnsGrid.push(item.id); // Populate column IDs
                    });
                    var difference = columnsGrid.filter((x) => Object.keys(data.data[0]).indexOf(x) === -1); // Check for missing columns
                    if (difference.length > 0) {
                        difference.forEach((id) => {
                            if (id != 'detailTittle') {
                                grid.hideColumn(id); // Hide missing columns
                            }
                        });
                        grid.refreshColumns(); // Refresh grid columns
                    }
                });
                $$('toolbar1').show(); // Show first toolbar
                $$('toolbar2').hide(); // Hide second toolbar
            } else {
                if (screen.width > 500 && screen.height > 500) {
                    $$('dColl').collapse(); // Collapse details if screen size is large
                }
                grid2.show(); // Show secondary grid
                grid.hide(); // Hide main grid
                grid2.clearAll(); // Clear secondary grid data
                grid2.load(url2 + '?start=0&count=' + grid2.data.$pagesize + string1 + string2).then(function (data) {
                    data = data.json(); // Parse loaded data
                    var columnsGrid = []; // Array to hold column IDs
                    grid2.config.columns.forEach((item) => {
                        columnsGrid.push(item.id); // Populate column IDs
                    });
                    var difference = columnsGrid.filter((x) => Object.keys(data.data[0]).indexOf(x) === -1); // Check for missing columns
                    if (difference.length > 0) {
                        difference.forEach((id) => {
                            grid2.hideColumn(id); // Hide missing columns
                        });
                        grid2.refreshColumns(); // Refresh grid columns
                    }
                });
                grid2.adjust(); // Adjust secondary grid layout
                $$('toolbar2').show(); // Show second toolbar
                $$('toolbar1').hide(); // Hide first toolbar
            }
            filter = string1 + string2; // Update filter string
            $$('filterPopup').hide(); // Hide filter popup
        });

        // Event handler for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });

        // Event handler for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id); // Load data for selected player
        });

        // Event handler for export filtering
        this.on(this.app, 'export:filter', (filterData) => {
            flag = true; // Set export flag
            var firstfirst;
            if (filterData.first == 0) {
                firstfirst = filterData.first + 1; // Adjust first index for export
            } else {
                firstfirst = filterData.first; // Use original first index
            }
            grid.load(url + '?start=' + firstfirst + '&count=' + (filterData.last + 1) + filter); // Load data for export
            grid.attachEvent(
                'onAfterLoad',
                function () {
                    if (flag) {
                        var size = grid.getPager().config.size; // Get page size
                        var page = grid.getPage(); // Get current page
                        var first = size * page; // Calculate first index for export
                        var last = first + size - 1; // Calculate last index for export
                        if ($$('Export1').getValue() == '1') {
                            console.log('Entro'); // Log for debugging
                            for (var j = 0; j < grid.config.columns.length; j++) {
                                if (grid.config.columns[j].exportType) {
                                    delete grid.config.columns[j].format; // Remove format for export
                                }
                            }
                            this.app.callEvent('export:data', [
                                {
                                    NameReport:
                                        _('Casino') +
                                        ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                        ' - ' +
                                        new Date().toLocaleString(), // Report name
                                    TypeReport: 'Excel', // Report type
                                },
                            ]);
                            webix.toExcel(grid, {
                                filter: function (obj) {
                                    return grid.getIndexById(obj.id) >= first && grid.getIndexById(obj.id) <= last; // Filter for export
                                },
                                filename:
                                    'Virtualsoft - ' +
                                    new Date()
                                        .toLocaleString('en-GB', {
                                            hour12: true,
                                        })
                                        .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                        .replace(/[\/:]/g, '_')
                                        .toUpperCase() +
                                    ' - ' +
                                    ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                    _('Casino'), // Filename for export
                                ignore: { detailTittle: true, Type: true }, // Columns to ignore in export
                                footer: false, // Disable footer in export
                            });
                        } else {
                            if ($$('Export1').getValue() == '2') {
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            _('Casino') +
                                            ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                            ' - ' +
                                            new Date().toLocaleString(), // Report name
                                        TypeReport: 'PDF', // Report type
                                    },
                                ]);
                                webix.toPDF(grid, {
                                    filter: function (obj) {
                                        return grid.getIndexById(obj.id) >= first && grid.getIndexById(obj.id) <= last; // Filter for export
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Casino'), // Filename for export
                                    autowidth: true, // Auto width for PDF
                                    ignore: { detailTittle: true, Type: true }, // Columns to ignore in export
                                    footer: false, // Disable footer in export
                                });
                            }
                        }
                        flag = false; // Reset export flag
                        $$('Export1').setValue(''); // Reset export selection
                    }
                }.bind(this),
            );
        });

        // Popup for user information
        var popupUser = webix.ui({
            view: 'window',
            id: 'popupUser',
            width: 700,
            height: 800,
            fullscreen: screen.width < 500 ? true : false, // Fullscreen for small screens
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Información'), align: 'center' }, // Title for popup
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            $$('formUser').clear(); // Clear form on close
                            this.getTopParentView().hide(); // Hide popup
                        },
                    },
                ],
            },
            position: 'center', // Center position for popup
            modal: true, // Modal popup
            body: {
                view: 'scrollview',
                scroll: 'y',
                body: {
                    view: 'form',
                    id: 'formUser',
                    elements: [
                        {
                            margin: 10,
                            cols: [
                                {
                                    rows: [
                                        {
                                            view: 'text',
                                            name: 'Id',
                                            label: _("<span class='icon-id'></span> ID"),
                                            labelPosition: 'top',
                                            placeholder: _('Id'),
                                            invalidMessage: _('A ID is required'), // Validation message
                                            disabled: true, // Disabled field
                                        },
                                        {
                                            view: 'text',
                                            name: 'FirstName',
                                            label: _('Primer nombre'),
                                            labelPosition: 'top',
                                            placeholder: _('Primer nombre'),
                                            invalidMessage: _('A name is required'), // Validation message
                                        },
                                        {
                                            view: 'text',
                                            name: 'MiddleName',
                                            label: _('Segundo Nombre'),
                                            labelPosition: 'top',
                                            placeholder: _('Segundo Nombre'),
                                            invalidMessage: _('A name is required'), // Validation message
                                        },
                                        {
                                            view: 'text',
                                            name: 'LastName',
                                            label: _('Apellido'),
                                            labelPosition: 'top',
                                            placeholder: _('Apellido'),
                                        },
                                        {
                                            view: 'text',
                                            name: 'SecondLastName',
                                            label: _('Segundo Apellido'),
                                            labelPosition: 'top',
                                            placeholder: _('Segundo Apellido'),
                                        },
                                        {
                                            view: 'richselect',
                                            name: 'DocumentType',
                                            localId: 'DocumentType:combo',
                                            label: _('Tipo de Documento'),
                                            labelPosition: 'top',
                                            placeholder: _('Click para seleccionar '),
                                            options: [
                                                { id: 'C', value: _('DNI') },
                                                {
                                                    id: 'E',
                                                    value: _('Cedula de Extranjería'),
                                                },
                                                {
                                                    id: 'P',
                                                    value: _('Pasaporte'),
                                                },
                                            ],
                                            disabled: false, // Enabled field
                                        },
                                        {
                                            view: 'text',
                                            name: 'DocNumber',
                                            label: _('Numero de Documento'),
                                            labelPosition: 'top',
                                            placeholder: _('Numero de Documento'),
                                        },
                                        {
                                            view: 'richselect',
                                            name: 'Gender',
                                            localId: 'Gender:combo',
                                            label: _('Género'),
                                            labelPosition: 'top',
                                            placeholder: _('Click para seleccionar '),
                                            options: ['M', 'F'], // Gender options
                                            disabled: true, // Disabled field
                                        },
                                        {
                                            view: 'datepicker',
                                            name: 'BirthDate',
                                            label: _('Cumpleaños'),
                                            labelPosition: 'top',
                                            placeholder: _('Click para seleccionar '),
                                            format: webix.Date.dateToStr('%d %M %Y'), // Date format
                                            disabled: false, // Enabled field
                                        },
                                        {
                                            view: 'text',
                                            name: 'Currency',
                                            label: "<span class='webix_icon mdi mdi-coin'></span>" + _('Moneda'),
                                            labelPosition: 'top',
                                            placeholder: _('Moneda'),
                                            disabled: true, // Disabled field
                                        },
                                        {
                                            view: 'text',
                                            name: 'Balance',
                                            label: _('Balance'),
                                            labelPosition: 'top',
                                            placeholder: _('Balance'),
                                            disabled: true, // Disabled field
                                        },
                                        {
                                            view: 'richselect',
                                            name: 'Estado',
                                            label: _('Estado'),
                                            labelPosition: 'top',
                                            localId: 'Estado:combo',
                                            placeholder: _('Click para seleccionar '),
                                            options: [
                                                { id: 'A', value: _('Active') },
                                                {
                                                    id: 'I',
                                                    value: _('Inactive'),
                                                },
                                            ],
                                            disabled: true, // Disabled field
                                        },
                                        {
                                            view: 'richselect',
                                            name: 'StateSpecial',
                                            label: _('Estado Especial'),
                                            labelPosition: 'top',
                                            placeholder: _('Click para seleccionar '),
                                            options: [
                                                { id: 'A', value: _('Active') },
                                                {
                                                    id: 'I',
                                                    value: _('Inactive'),
                                                },
                                            ],
                                            disabled: true, // Disabled field
                                        },
                                        {
                                            view: 'text',
                                            name: 'IsLocked',
                                            label: _('Está bloqueado?'),
                                            labelPosition: 'top',
                                            placeholder: _('Está bloqueado?'),
                                            disabled: true, // Disabled field
                                        },
                                    ],
                                },
                                {
                                    rows: [
                                        {
                                            view: 'richselect',
                                            name: 'CountryId',
                                            id: 'country',
                                            localId: 'country:combo',
                                            label: _('País Residencia'),
                                            labelPosition: 'top',
                                            placeholder: _('Click para seleccionar '),
                                            options: [],
                                            disabled: true, // Disabled field
                                        },
                                        {
                                            view: 'richselect',
                                            name: 'RegionId',
                                            id: 'ProvinceRegion',
                                            localId: 'ProvinceRegion:combo',
                                            label: _('Provincia/Región Residencia'),
                                            labelPosition: 'top',
                                            placeholder: _('Click para seleccionar '),
                                            options: [],
                                            disabled: true, // Disabled field
                                        },
                                        {
                                            view: 'richselect',
                                            name: 'CityId',
                                            id: 'City',
                                            localId: 'cities:combo',
                                            label: _('Ciudad Residencia'),
                                            labelPosition: 'top',
                                            placeholder: _('Click para seleccionar '),
                                            options: [],
                                            disabled: true, // Disabled field
                                        },
                                        {
                                            view: 'text',
                                            name: 'Address',
                                            label: _('Dirección'),
                                            labelPosition: 'top',
                                            placeholder: _('Dirección'),
                                            disabled: false, // Enabled field
                                        },
                                        {
                                            view: 'text',
                                            name: 'ZipCode',
                                            label: _('Código Zip'),
                                            labelPosition: 'top',
                                            placeholder: _('Código Zip'),
                                            disabled: true, // Disabled field
                                        },
                                        {
                                            view: 'text',
                                            name: 'Phone',
                                            label: "<span class='icon-phone1'></span>" + _('Teléfono'),
                                            labelPosition: 'top',
                                            placeholder: _('Teléfono'),
                                            type: 'number',
                                            disabled: false, // Enabled field
                                        },
                                        {
                                            view: 'text',
                                            name: 'MobilePhone',
                                            label: _('Celular'),
                                            labelPosition: 'top',
                                            placeholder: _('Celular'),
                                            type: 'number',
                                            disabled: false, // Enabled field
                                        },
                                        {
                                            view: 'richselect',
                                            name: 'CellStatus',
                                            label: _('Estado Celular'),
                                            labelPosition: 'top',
                                            localId: 'Estado:combo',
                                            placeholder: _('Click para seleccionar '),
                                            options: [
                                                {
                                                    id: '0',
                                                    value: _('Verificado'),
                                                },
                                                {
                                                    id: '1',
                                                    value: _('Sin verificar'),
                                                },
                                            ],
                                            disabled: true, // Disabled field
                                        },
                                        {
                                            view: 'text',
                                            name: 'Email',
                                            label: _('Email'),
                                            labelPosition: 'top',
                                            placeholder: _('Email'),
                                            disabled: false, // Enabled field
                                        },
                                        {
                                            view: 'text',
                                            name: 'CreatedLocalDate',
                                            label: _('Fecha de registro'),
                                            labelPosition: 'top',
                                            placeholder: _('Fecha de registro'),
                                            disabled: true, // Disabled field
                                        },
                                        {
                                            view: 'text',
                                            name: 'LastLoginLocalDate',
                                            label: _('Fecha de ultimo login'),
                                            labelPosition: 'top',
                                            placeholder: _('Fecha de ultimo login'),
                                            disabled: true, // Disabled field
                                        },
                                        {
                                            view: 'text',
                                            name: 'LastIPaddress',
                                            label: _('Última dirección IP'),
                                            labelPosition: 'top',
                                            placeholder: _('Última dirección IP'),
                                            disabled: true, // Disabled field
                                        },
                                        {
                                            view: 'button',
                                            value: _('Ir al usuario'),
                                            type: 'form',
                                            click: function (obj) {
                                                var values = $$('formUser').getValues(); // Get form values
                                                window.open(
                                                    '/#!/top/customers?user=' + values.Id + '/information', // Open user information page
                                                    '_blank',
                                                );
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            },
        });

        // Event handler for displaying user information in a popup
        this.on(this.app, 'popupUserIframe', (id) => {
            webix
                .ui({
                    view: 'window',
                    id: 'popupUserIframe',
                    head: {
                        view: 'toolbar',
                        cols: [
                            {
                                view: 'label',
                                label: _('Información'),
                                align: 'center', // Center label
                            },
                            {
                                view: 'icon',
                                icon: 'wxi-close',
                                click: function () {
                                    this.getTopParentView().hide(); // Hide popup on close
                                },
                            },
                        ],
                    },
                    position: 'center', // Center position for popup
                    modal: true, // Modal popup
                    body: {
                        view: 'iframe',
                        id: 'frame-body',
                        src: '/#!/top/customers?user=' + id + '/information', // Source for iframe
                    },
                })
                .show(); // Show the popup
            $$('popupUserIframe').setPosition(15, 15); // Set position for popup
            $$('popupUserIframe').$setSize($(window).width() - 30, $(window).height() - 30); // Set size for popup
        });

        // Event handler for updating user form data
        this.on(this.app, 'form:update', (id) => {
            webix.ajax().get(devConfig.geturlApi() + 'Client/GetClientById', 'id=' + id, {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message
                },
                success: function (text, data, XmlHttpRequest) {
                    text = JSON.parse(text); // Parse response
                    vthis.app.callEvent('customer:updatedata', [text[0]]); // Trigger update event
                    $$('country').setValue(text[0].CountryId); // Set country value
                    webix.delay(
                        function () {
                            $$('ProvinceRegion').setValue(text[0].RegionId); // Set region value
                            webix.delay(
                                function () {
                                    $$('City').setValue(text[0].CityId); // Set city value
                                },
                                '',
                                '',
                                1000,
                            );
                        },
                        '',
                        '',
                        1000,
                    );
                },
            });
        });

        // Event handler for updating user form with new data
        this.on(this.app, 'customer:updatedata', (person) => {
            $$('formUser').setValues(person); // Set form values
        });

        // Event handler for country selection
        $$('country').attachEvent('onItemClick', function (id, e) {
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json',
                })
                .post(devConfig.geturlApi() + 'Agent/GetAgentCountries', '', {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Error message
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var data = JSON.parse(text.replace(/"Id"/g, '"id"').replace(/"Name"/g, '"value"')); // Parse response
                        var optionsCountries = $$('country').getList(); // Get country options
                        optionsCountries.clearAll(); // Clear existing options
                        optionsCountries.parse(data.Data); // Parse new options
                    },
                });
        });

        // Event handler for country change
        $$('country').attachEvent('onChange', function (newv, oldv) {
            var optionscountries = this.getList().getItem(newv); // Get selected country
            var optionsProvinceRegions = $$('ProvinceRegion').getList(); // Get province/region options
            if (optionscountries != undefined) {
                optionsProvinceRegions.clearAll(); // Clear existing options
                optionsProvinceRegions.parse(optionscountries.departments); // Parse new options
            }
        });

        // Event handler for province/region change
        $$('ProvinceRegion').attachEvent('onChange', function (newv, oldv) {
            var optionsProvinceRegions = this.getList().getItem(newv); // Get selected province/region
            var optionsCity = $$('City').getList(); // Get city options
            optionsCity.clearAll(); // Clear existing options
            if (optionsProvinceRegions != undefined) {
                optionsCity.parse(optionsProvinceRegions.cities); // Parse new options
            }
        });
    }
}

// FILE DOCUMENTED
